import React, { Fragment } from "react";

interface IProps {
    alertInfo: any;
}

const IDFPaydayLoan = ({ alertInfo }: any) => {
    const paydayLoanAlertdetails = alertInfo && alertInfo.length > 0 && alertInfo[0].alertDetails && alertInfo[0].alertDetails.alertItemDetailsListList;

    if (!paydayLoanAlertdetails) {
        return <Fragment></Fragment>;
    }

    return (
        <>
            <h4 className="content-sub-title">Addresses</h4>

            {paydayLoanAlertdetails["addresses"].map((alert: any, index: number) => {
                let keys = Object.keys(alert);

                return (
                    <>
                        {keys.length !== 0 && (
                            <div role="listitem" className="data-row" key={index}>
                                <div className="link-item">
                                    <button
                                        type="button"
                                        aria-expanded="false"
                                        className="link-button"
                                        id={`address-${index}`}
                                        onClick={() => toggle(`address-${index}-details`, `address-${index}`)}
                                    >
                                        <span className="row link-item">
                                            <div role="row" className="data-row condensed row">
                                                <span className="link-title">
                                                    <span className="col-xs-12 col-sm-4 col-no-gutter btn-toggle-status" style={{ display: "none" }}>
                                                        Show
                                                    </span>
                                                </span>

                                                {
                                                    <Fragment>
                                                        <div role="gridcell" className="col-xs-12 col-sm-4 col-no-gutter btn-toggle-status">
                                                            <div className="data-label">{`Address`}</div>
                                                        </div>
                                                        <div role="gridcell" className="col-xs-12 col-sm-8 col-no-gutter">
                                                            <div className="data-value" aria-labelledby={`address-${index}`}>{`${alert["Address 1"]}`}</div>
                                                        </div>
                                                    </Fragment>
                                                }
                                            </div>
                                        </span>
                                    </button>
                                    <div
                                        className="wallet-details"
                                        key={alert.alertId}
                                        id={`address-${index}-details`}
                                        style={{ display: "none", backgroundColor: "#F2F2F2" }}
                                        aria-hidden="true"
                                    >
                                        <div role="grid" className="data-grid row-height-xs" aria-labelledby={"address-" + index + "-title"}>
                                            {keys.map((key: any) => {
                                                return (
                                                    <div role="row" key={`${key}-${index}`} className="data-row condensed row">
                                                        {key !== "Address 1" && (
                                                            <>
                                                                <div role="gridcell" className="col-xs-12 col-sm-4 col-no-gutter">
                                                                    <div className="data-label" id={`address-${index}-${key}`}>
                                                                        {key}
                                                                    </div>
                                                                </div>
                                                                <div role="gridcell" className="col-xs-12 col-sm-8 col-no-gutter">
                                                                    <div className="data-value" aria-labelledby={`address-${index}-${key}`}>
                                                                        {alert[key]}
                                                                    </div>
                                                                </div>
                                                            </>
                                                        )}
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </>
                );
            })}

            {<h4 className="content-sub-title">Loans</h4>}

            {paydayLoanAlertdetails["loans"].map((alert: any, index: number) => {
                let keys = Object.keys(alert);

                return (
                    <>
                        {keys.length !== 0 && (
                            <div role="listitem" className="data-row" key={index}>
                                <div className="link-item">
                                    <button
                                        type="button"
                                        aria-expanded="false"
                                        className="link-button"
                                        id={`loan-${index}`}
                                        onClick={() => toggle(`loan-${index}-details`, `loan-${index}`)}
                                    >
                                        <span className="row link-item">
                                            <div role="row" className="data-row condensed row">
                                                <span className="link-title">
                                                    <span className="col-xs-12 col-sm-4 col-no-gutter btn-toggle-status" style={{ display: "none" }}>
                                                        Show
                                                    </span>
                                                </span>

                                                {
                                                    <Fragment>
                                                        <div role="gridcell" className="col-xs-12 col-sm-4 col-no-gutter btn-toggle-status">
                                                            <div className="data-label">Loan Date</div>
                                                        </div>
                                                        <div role="gridcell" className="col-xs-12 col-sm-8 col-no-gutter">
                                                            <div className="data-value" aria-labelledby={`loan-${index}`}>{`${alert["Loan Date"]}`}</div>
                                                        </div>
                                                    </Fragment>
                                                }
                                            </div>
                                        </span>
                                    </button>
                                    <div
                                        className="wallet-details"
                                        key={alert.alertId}
                                        id={`loan-${index}-details`}
                                        style={{ display: "none", backgroundColor: "#F2F2F2" }}
                                        aria-hidden="true"
                                    >
                                        <div role="grid" className="data-grid row-height-xs" aria-labelledby={"loan-" + index + "-title"}>
                                            {keys.map((key: any) => {
                                                return (
                                                    <div role="row" key={`${key}-${index}`} className="data-row condensed row">
                                                        {key !== "Loan Date" && (
                                                            <>
                                                                <div role="gridcell" className="col-xs-12 col-sm-4 col-no-gutter">
                                                                    <div className="data-label" id={`loan-${index}-${key}`}>
                                                                        {key}
                                                                    </div>
                                                                </div>
                                                                <div role="gridcell" className="col-xs-12 col-sm-8 col-no-gutter">
                                                                    <div className="data-value" aria-labelledby={`loan-${index}-${key}`}>
                                                                        {alert[key]}
                                                                    </div>
                                                                </div>
                                                            </>
                                                        )}
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </>
                );
            })}

            {<h4 className="content-sub-title">Inquiries</h4>}

            {paydayLoanAlertdetails["inquiries"].map((alert: any, index: number) => {
                let keys = Object.keys(alert);

                return (
                    <>
                        {keys.length !== 0 && (
                            <div role="listitem" className="data-row" key={index}>
                                <div className="link-item">
                                    <button
                                        type="button"
                                        aria-expanded="false"
                                        className="link-button"
                                        id={`inquiry-${index}`}
                                        onClick={() => toggle(`inquiry-${index}-details`, `inquiry-${index}`)}
                                    >
                                        <span className="row link-item">
                                            <div role="row" className="data-row condensed row">
                                                <span className="link-title">
                                                    <span className="col-xs-12 col-sm-4 col-no-gutter btn-toggle-status" style={{ display: "none" }}>
                                                        Show
                                                    </span>
                                                </span>

                                                {
                                                    <Fragment>
                                                        <div role="gridcell" className="col-xs-12 col-sm-4 col-no-gutter btn-toggle-status">
                                                            <div className="data-label">Inquiry Date</div>
                                                        </div>
                                                        <div role="gridcell" className="col-xs-12 col-sm-8 col-no-gutter">
                                                            <div className="data-value" aria-labelledby={`inquiry-${index}`}>{`${alert["Inquiry Date"]}`}</div>
                                                        </div>
                                                    </Fragment>
                                                }
                                            </div>
                                        </span>
                                    </button>
                                    <div
                                        className="wallet-details"
                                        key={alert.alertId}
                                        id={`inquiry-${index}-details`}
                                        style={{ display: "none", backgroundColor: "#F2F2F2" }}
                                        aria-hidden="true"
                                    >
                                        <div role="grid" className="data-grid row-height-xs" aria-labelledby={"inquiry-" + index + "-title"}>
                                            {keys.map((key: any) => {
                                                return (
                                                    <div role="row" key={`${key}-${index}`} className="data-row condensed row">
                                                        {key !== "Inquiry Date" && (
                                                            <>
                                                                <div role="gridcell" className="col-xs-12 col-sm-4 col-no-gutter">
                                                                    <div className="data-label" id={`inquiry-${index}-${key}`}>
                                                                        {key}
                                                                    </div>
                                                                </div>
                                                                <div role="gridcell" className="col-xs-12 col-sm-8 col-no-gutter">
                                                                    <div className="data-value" aria-labelledby={`inquiry-${index}-${key}`}>
                                                                        {alert[key]}
                                                                    </div>
                                                                </div>
                                                            </>
                                                        )}
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </>
                );
            })}
        </>
    );
};

export default IDFPaydayLoan;
